import { CalendarDays, Utensils, KeyRound, ExternalLink, Smartphone, TreePine } from "lucide-react";

const APPS = [
  { key: "prenotazioni", label: "Apri app Prenotazioni", href: "/prenotazioni", icon: CalendarDays, primary: true },
  { key: "ristorante", label: "Ristorante", href: "/ristorante", icon: Utensils },
  { key: "checkin", label: "Check-in", href: "/checkin", icon: KeyRound },
  { key: "ambienti", label: "Ambienti", href: "/ambienti", icon: TreePine },
];

export function StaffAppsBar() {
  return (
    <div className="mb-4 rounded-2xl border border-[#4a1c17]/15 bg-white px-4 py-3 shadow-sm" data-testid="staff-apps-bar">
      <div className="flex flex-wrap items-center gap-2">
        <div className="mr-1 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-[#4a1c17]/70">
          <Smartphone className="h-4 w-4" /> App Staff
        </div>
        {APPS.map(({ key, label, href, icon: Icon, primary }) => (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noreferrer"
            data-testid={`staff-app-link-${key}`}
            className={
              primary
                ? "inline-flex items-center gap-1.5 rounded-full bg-[#4a1c17] px-4 py-2 text-sm font-semibold text-[#f7ebdf] hover:bg-[#2b1410] transition-colors"
                : "inline-flex items-center gap-1.5 rounded-full border border-[#4a1c17]/25 px-3 py-2 text-sm font-medium text-[#4a1c17] hover:bg-[#f7ebdf] transition-colors"
            }
          >
            <Icon className="h-4 w-4" /> {label} <ExternalLink className="h-3.5 w-3.5 opacity-60" />
          </a>
        ))}
      </div>
      <p className="mt-2 text-xs text-[#4a1c17]/60" data-testid="staff-apps-note">
        Per l'icona sulla Home: apri il link <b>da Chrome o Safari sul telefono</b> (non dall'app Admin installata) e tocca il tasto <b>Aggiungi alla Home</b> nella schermata del PIN. Se sei dentro l'app Admin: ⋮ → <b>Apri in Chrome</b>.
      </p>
    </div>
  );
}
